import React, {Component} from 'react';
import notifier from './../lib/notifier';
import {Container} from "reactstrap";
import {post} from './../lib/http';

export class HealthAndSafetyData extends Component {
    render() {
        const handleChange = (event) => {
            const element = event.target;
            const file = element.files[0];

            if (file) {
                post(`api/incidents/upload`, '', (result) => {
                    notifier.notify({
                        level: notifier.Level.Success,
                        title: 'Success',
                        message: 'File uploaded'
                    });
                }, [file]);
            }
        };

        const apiKey = window.localStorage.getItem('apiKey') || '';

        return (
            <Container fluid>
                <h1>Health and safety data</h1>

                <label className="btn btn-default btn-file mr-3">
                    Upload
                    <input
                        type="file"
                        onChange={handleChange}
                        style={{display: 'none'}}/>
                </label>

                <a href={`/api/incidents/download?api-key=${encodeURIComponent(apiKey)}`} rel="noopener noreferrer" target="_blank">Download</a>
            </Container>
        );
    }
}